import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t, i18n } = useTranslation();

  const FOOTER_LINKS = [
    {
      title: t('footer.group_product'),
      links: [
        { label: t('navbar.features'), href: "#features" },
        { label: t('navbar.howItWorks'), href: "#how-it-works" },
        { label: t('navbar.faq'), href: "#faq" },
      ],
    },
    {
      title: t('footer.group_support'),
      links: [
        { label: t('footer.contact'), href: "mailto:support@visipo.com" },
      ],
    },
    {
      title: t('footer.group_legal'),
      links: [
        { label: t('footer.terms'), href: i18n.language.startsWith('en') ? "/en/terms" : "/terms" },
        { label: t('footer.privacy'), href: i18n.language.startsWith('en') ? "/en/privacy" : "/privacy" },
      ],
    },
  ];
  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith("#") && href.length > 1) {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="pt-16 pb-8" style={{ background: "#1a2332" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img
                src="/logo.png"
                alt="Visipo Logo"
                className="h-8 w-auto object-contain"
              />
              <span className="text-white font-bold text-xl" style={{ fontFamily: "'Inter', sans-serif" }}>Visipo</span>
            </div>
            <p className="text-sm leading-relaxed mb-6 whitespace-pre-wrap" style={{ color: "rgba(255,255,255,0.45)", fontFamily: "'Noto Sans JP', sans-serif" }}>
              {t('footer.brand_desc')}
            </p>

          </div>

          {/* Link Columns */}
          {FOOTER_LINKS.map((col) => (
            <div key={col.title}>
              <h4 className="text-white font-bold text-sm mb-5 tracking-wide" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                {col.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith("http") || link.href.startsWith("mailto") || link.href.startsWith("#") ? (
                      <a
                        href={link.href}
                        onClick={(e) => handleNav(e, link.href)}
                        className="text-sm transition-colors duration-200 cursor-pointer hover:text-[#13B6EC]"
                        style={{ color: "rgba(255,255,255,0.45)", fontFamily: "'Noto Sans JP', sans-serif" }}
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-sm transition-colors duration-200 cursor-pointer hover:text-[#13B6EC]"
                        style={{ color: "rgba(255,255,255,0.45)", fontFamily: "'Noto Sans JP', sans-serif" }}
                        onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>


        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs" style={{ color: "rgba(255,255,255,0.3)", fontFamily: "'Noto Sans JP', sans-serif" }}>
            {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-4">
            <Link to={i18n.language.startsWith('en') ? "/en/terms" : "/terms"} onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} className="text-xs cursor-pointer hover:text-white transition-colors" style={{ color: "rgba(255,255,255,0.3)", fontFamily: "'Noto Sans JP', sans-serif" }}>
              {t('footer.terms')}
            </Link>
            <Link to={i18n.language.startsWith('en') ? "/en/privacy" : "/privacy"} onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} className="text-xs cursor-pointer hover:text-white transition-colors" style={{ color: "rgba(255,255,255,0.3)", fontFamily: "'Noto Sans JP', sans-serif" }}>
              {t('footer.privacy')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
